import { U as Url } from './url.min.js';

/**
 * **Viato**
 *
 * @exports bs_232
 * @category engines
 */
function factory({ window, document, thn }) {
    const engine = {};
    /**
       * @memberOf module:bs_232
       * @see {@link prestart}
       *
       * @param {object} ctx - The context object.
       */
    engine.boot = function boot() {
        const $ = window.jQuery;
        if (!$) {
            return;
        }
        // eslint-disable-next-line vars-on-top
        var $loader = $('.loading');
        if ($loader.length) {
            const check = thn.debounce(function viatoCheck() {
                if (!$loader.is(':visible')) {
                    thn.pageCheck();
                }
            }, 250);
            thn.observeDom($loader.get(0), check);
            thn.shutdown(function () {
                thn.stopObserveDom($loader.get(0), check);
            });
        }
        const debouncedPageCheck = thn.debounce(thn.pageCheck, 500);
        const selectors = 'button[class^=btn-back], button[id^=next-step], .prevdef';
        $(document).on('click', selectors, debouncedPageCheck);
        thn.shutdown(function () {
            $(document).off('click', selectors, debouncedPageCheck);
        });
        const container = document.querySelector('html');
        if (container && !thn.viatoPageRefresh) {
            const viatoPageRefreshPage = thn.debounce(function () {
                thn.pageCheck();
            }, 600);
            thn.viatoPageRefresh = function (mutations) {
                const validMutationsRefreshBookingPage = [...mutations].map((mutation) => mutation.addedNodes.length && [...mutation.addedNodes].map((node) => node.id === 'bookingTxt').filter(Boolean)).filter((el) => !thn.empty(el));
                if (validMutationsRefreshBookingPage.length) {
                    viatoPageRefreshPage();
                }
            };
            thn.observeDom(container, thn.viatoPageRefresh, {
                childList: true,
                subTree: true,
                attributes: true,
            });
            thn.shutdown(function () {
                viatoPageRefreshPage.cancel();
                thn.stopObserveDom(container, thn.viatoPageRefresh);
                delete thn.viatoPageRefresh;
            });
        }
    };
    /**
       * @memberOf module:bs_232
       * @see {@link language_check}
       *
       * @param {object} ctx - The context object.
       */
    engine.languageCheck = function languageCheck(ctx) {
        let aux;
        let langEl;
        return new Promise(function (resolve, reject) {
            // On Booking Engine
            if (window.location.hostname.match(/booking.viatocrs.de/)) {
                langEl = document.querySelector('.btn-toolbar button.dropdown-toggle span');
                if (langEl) {
                    aux = langEl.textContent.toLowerCase();
                    if (aux && ctx.langs.test(aux)) {
                        resolve(aux);
                        return;
                    }
                }
                aux = thn.parseUrlParameter('lng');
                if (aux && ctx.langs.test(aux)) {
                    resolve(aux);
                    return;
                }
            }
            // For hotel page go for the default html.lang
            reject('no_language');
        });
    };
    /**
       * @memberOf module:bs_232
       * @see {@link generate_search_url}
       *
       * @param {object} ctx - The context object.
       */
    engine.generateSearchUrl = function generateSearchUrl(ctx) {
        const url = new Url(ctx.baseUrl);
        if (url.host.match(/viatocrs/)) {
            // URL ---> https://booking.viatocrs.de/cbe-relaunch/index.html?pr=XRomJI39ByaD&lng=en&promo_code=Mobile
            url.path = '/cbe-relaunch/index.html';
            // remove referrer parameter
            if (url.query.parentUrl) {
                delete url.query.parentUrl;
            }
            url.query.arrival = '[date_begin]';
            url.query.departure = '[date_end]';
            url.query.lng = '[language]';
            // Export into ctx.new_url
            ctx.newUrl = url.decode(url.toString());
            // Then format of dates: yyyy/mm/dd -> yyyy-mm-dd
            ctx.newData.dateBegin = ctx.newData.dateBegin && ctx.newData.dateBegin.replace(/\//g, '-');
            ctx.newData.dateEnd = ctx.newData.dateEnd && ctx.newData.dateEnd.replace(/\//g, '-');
        }
        else {
            // This is not a valid BE URL
            ctx.newUrl = '';
        }
        return ctx;
    };
    /**
       * @memberOf module:bs_232
       * @this thn.widgets.price
       * @see {@link Price#observe_dom}
       *
       * @param {object} ctx - The context object.
       */
    engine.priceObserveDom = function priceObserveDom(ctx) {
        const $ = window.jQuery;
        const widget = this;
        // observe the main page loader
        if (!thn.viatoUpdater) {
            const loader = document.querySelector('.loading');
            thn.viatoUpdater = thn.debounce(function thnViatoUpdater() {
                // Do nothing while loading
                if (!loader || thn.isVisible(loader)) {
                    widget.hide();
                    return;
                }
                // Otherwise check for language changes
                thn.languageCheck().then(function ({ changed }) {
                    if (!changed) {
                        if (widget.isSet()) {
                            widget.refresh();
                        }
                        else {
                            widget.update();
                        }
                    }
                });
            }, 1000);
            if (loader) {
                thn.observeDom(loader, thn.viatoUpdater, {
                    childList: false,
                    subtree: false,
                    characterData: false,
                    attributes: true,
                    attributeFilter: ['style'],
                });
                thn.pageUnload(function () {
                    thn.stopObserveDom(loader, thn.viatoUpdater);
                });
            }
            // watch "adults" checkbox clicks
            $(document).on('click', '.adults .adult', thn.viatoUpdater);
            const firstStep = document.querySelector('.step-1');
            if (firstStep) {
                const pageCheckFunc = thn.debounce(thn.pageCheck, 1000);
                thn.observeDom(firstStep, pageCheckFunc, {
                    childList: false,
                    subtree: false,
                    characterData: false,
                    attributes: true,
                    attributeFilter: ['class'],
                });
                thn.pageUnload(function () {
                    thn.stopObserveDom(firstStep, pageCheckFunc);
                });
            }
            thn.pageUnload(function () {
                $(document).off('click', '.adults .adult', thn.viatoUpdater);
                delete thn.viatoUpdater;
            });
        }
    };
    /**
       * @memberOf module:bs_232
       * @this thn.widgets.price
       * @see {@link Price#set_data}
       *
       * @param {object} ctx - The context object.
       */
    engine.priceParseData = function priceParseData(ctx) {
        const widgetData = {};
        // Exit if loading ...
        const loader = document.querySelector('.loading');
        if (loader && thn.isVisible(loader)) {
            return widgetData;
        }
        // Dates
        const dateBegin = document.getElementById('arrival');
        const dateEnd = document.getElementById('departure');
        if (dateBegin && dateEnd) {
            if (thn.data.language === 'de') {
                widgetData.dateBegin = dateBegin.value.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1');
                widgetData.dateEnd = dateEnd.value.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1');
            }
            else {
                widgetData.dateBegin = dateBegin.value.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$1/$2/$3');
                widgetData.dateEnd = dateEnd.value.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$1/$2/$3');
            }
        }
        let cbeDataObj;
        if (window.cbeData) {
            const cbeData = Object.keys(window.cbeData);
            cbeData.forEach(function (el) {
                if (el.toString().match(/jQuery/)) {
                    cbeDataObj = el;
                }
            });
        }
        widgetData.rooms = 1;
        if (cbeDataObj
            && window.cbeData
            && window.cbeData[cbeDataObj]
            && window.cbeData[cbeDataObj].data
            && window.cbeData[cbeDataObj].data.bookBasket
            && window.cbeData[cbeDataObj].data.bookBasket.rooms) {
            const basket = window.cbeData[cbeDataObj].data.bookBasket;
            const roomKey = Object.keys(basket.rooms);
            const roomObj = basket.rooms[roomKey[0]];
            // Currency
            if (window.cbeConfig
                && window.cbeConfig.settings
                && window.cbeConfig.settings.general
                && window.cbeConfig.settings.general.currency) {
                widgetData.currency = window.cbeConfig.settings.general.currency;
            }
            // price
            let cheapestPrice = Number.MAX_SAFE_INTEGER;
            let cheapestPriceIsSelected = false;
            let cheapestPriceFromRates = false;
            Array.from(document.querySelectorAll('.room-list-area .list-group-item')).forEach(function (el) {
                const price = thn.parseNumber(el.querySelector('.room-price').textContent) || Number.MAX_SAFE_INTEGER;
                if (price < cheapestPrice) {
                    cheapestPrice = price;
                    cheapestPriceIsSelected = el.classList.contains('active');
                }
            });
            if (cheapestPriceIsSelected) {
                // When the cheapest room is selected, then select the price from .rate-list
                // instead of from .room-list-area because the later doesn't reflect the
                // price for the selected number of guests ONLY if its the first one
                const ratePriceEl = document.querySelector('.rate-list .list-group-item.active .price');
                if (ctx.widget.isSet() && !ratePriceEl) {
                    // ABORT execution to keep the last PW
                    return widgetData;
                }
                cheapestPriceFromRates = true;
                cheapestPrice = thn.parseNumber(ratePriceEl.textContent);
            }
            // Price per night
            if (cheapestPrice !== Number.MAX_SAFE_INTEGER && widgetData.dateBegin && widgetData.dateEnd) {
                widgetData.price = Math.round((cheapestPrice / thn.daysBetween(widgetData.dateBegin, widgetData.dateEnd)) * 100) / 100;
                widgetData.set = true;
            }
            // Only use room_obj when the price has been picked from the .rate-list
            if (cheapestPriceFromRates) {
                widgetData.adults = roomObj.aOccu;
                widgetData.children = roomObj.cOccu;
            }
            // otherwise show 1 guest by default (as they do)
            widgetData.adults = widgetData.adults || 1;
            widgetData.children = widgetData.children || 0;
            widgetData.guests = Math.max(1, widgetData.adults + widgetData.children);
        }
        else {
            widgetData.noRooms = true;
        }
        return widgetData;
    };
    /**
       * @memberOf module:bs_232
       * @this thn.widgets.booking
       * @see {@link Booking#observe_dom}
       *
       * @param {object} ctx - The context object.
       */
    engine.bookingObserveDom = function bookingObserveDom(ctx) {
        const widget = this;
        const modal = document.querySelectorAll('.modal-body')[1];
        // If loading, observe
        if (modal && modal.querySelector('.loading')) {
            const bookingObserver = function observer() {
                if (!modal.querySelector('.loading')
                    && widget.setData().isSet()) {
                    // Once not-loading any more and widget data is set
                    widget.save();
                    thn.stopObserveDom(modal, observer);
                }
            };
            thn.observeDom(modal, bookingObserver);
            thn.pageUnload(function () {
                thn.stopObserveDom(modal, bookingObserver);
            });
        }
    };
    /**
       * @memberOf module:bs_232
       * @this thn.widgets.booking
       * @see {@link Booking#set_data}
       *
       * @param {object} ctx - The context object.
       */
    engine.bookingParseData = function bookingParseData(ctx) {
        const widgetData = {};
        const modal = document.querySelectorAll('.modal-body')[1];
        if (modal) {
            if (modal.querySelector('.loading')) {
                // Wait
                widgetData.set = false;
            }
            else {
                widgetData.bookingId = thn.dataLayerHelper.get('2.transaction_id') || thn.parseNumber(modal.textContent) || 0;
                widgetData.price = thn.dataLayerHelper.get('2.value') || thn.widgets.price.data.price;
                widgetData.currency = thn.dataLayerHelper.get('2.currency') || thn.widgets.price.data.currency;
                widgetData.dateBegin = thn.widgets.price.data.dateBegin;
                widgetData.dateEnd = thn.widgets.price.data.dateEnd;
            }
        }
        return widgetData;
    };
    /**
       * @memberOf module:bs_232
       * @this thn.widgets.price
       * @see {@link Price#get_promocode}
       *
       * @param {object} ctx - The context object.
       */
    engine.getPromocode = function getPromocode(ctx) {
        const promocodeEl = document.querySelector('#promo-code');
        if (promocodeEl && promocodeEl.value) {
            ctx.promocode = promocodeEl.value;
        }
        return ctx.promocode;
    };
    return engine;
}

export { factory };
